import React from "react";

interface PageProps {
  children: React.ReactNode;
  isTripBuilderPage?: boolean;
}

const Page = ({ children, isTripBuilderPage }: PageProps) => {
  return (
    <section
      id={isTripBuilderPage ? "main-content-trip-builder" : "main-content"}
      className="z-0 h-dvh overflow-hidden"
    >
      <div
        className={`flex flex-col h-[calc(100%-5px)] w-full overflow-hidden ${
          isTripBuilderPage ? "p-0" : "pt-3 pl-3 pr-3 pb-1"
        }`}
      >
        {children}
      </div>
    </section>
  );
};

export default Page;
